export const PAY_COURSE_REQUEST = 'PAY_COURSE_REQUEST';
export const PAY_BUTTON_LOAD_SUCCESS = 'PAY_BUTTON_LOAD_SUCCESS';
export const PAY_BUTTON_LOAD_REQUEST = 'PAY_BUTTON_LOAD_REQUEST';
export const SET_CHECKOUT_SUCCESS = 'SET_CHECKOUT_SUCCESS';
export const RESET_CHECKOUT_SUCCESS = 'RESET_CHECKOUT_SUCCESS';
